import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overview-mini-calendar',
  templateUrl: './overview-mini-calendar.component.html',
  styleUrls: ['./overview-mini-calendar.component.scss']
})
export class OverviewMiniCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
